import { createContext, useContext } from 'react';

interface ObjectDetailContextValue {
  groupId: string;
  /** Spiegelt die Rollenprüfung des Layouts, damit Tabs sie nicht erneut herleiten. */
  canEdit: boolean;
}

export const ObjectDetailContext = createContext<ObjectDetailContextValue | null>(null);

export function useObjectDetail() {
  const value = useContext(ObjectDetailContext);
  if (!value) {
    throw new Error('useObjectDetail muss innerhalb des ObjectDetailLayout verwendet werden.');
  }
  return value;
}
